/* ==========================================================================
   Added by Sascha 18.06.2026
   ========================================================================== */


(function () {
  'use strict';

  document.documentElement.classList.add('gt-js');

  function initGtBulletReveal() {
    var items = document.querySelectorAll(
      '.gt-bullets > p:not(.gt-reveal), .gt-bullets > li:not(.gt-reveal)'
    );

    if (!items.length) return;

    items.forEach(function (item) {
      item.classList.add('gt-reveal');

      var siblings = Array.prototype.slice.call(item.parentElement.children);
      var index = siblings.indexOf(item);
      var delay = Math.min(index * 70, 420);

      item.style.setProperty('--gt-delay', delay + 'ms');
    });

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('gt-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('gt-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.16,
        rootMargin: '0px 0px -8% 0px'
      }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGtBulletReveal);
  } else {
    initGtBulletReveal();
  }

  document.addEventListener('shopify:section:load', initGtBulletReveal);
})();